import GuestHeader from '@/components/GuestHeader';
import { Globe, Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";


export default function InfoPage() {
  return (
    <div className="min-h-screen bg-[#F2F2F7] pb-28" data-testid="info-page">
      {/* Compact Header - 56px height */}
      <GuestHeader />

      {/* Content */}
      <main className="px-5 pt-6">
        <div className="max-w-lg mx-auto space-y-5">
          {/* About */}
          <section className="layer-card p-5">
            <h2 className="text-lg font-semibold text-slate-900 mb-3">
              About Disqover
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Disqover is the modern way to explore any destination. We curate the best 
              local experiences — from dining and wellness to nightlife and activities — 
              so you can discover quality places, instantly.
            </p>
            <p className="text-sm text-slate-600 leading-relaxed mt-3">
              Scan any Disqover QR code or share a link to access recommendations 
              tailored to your location. No app download required.
            </p>
          </section>

          {/* How it works */}
          <section className="layer-card p-5">
            <h2 className="text-lg font-semibold text-slate-900 mb-5">
              How it works
            </h2>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 rounded-2xl bg-teal-50 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-teal-600">1</span>
                </div>
                <div className="pt-1">
                  <h3 className="text-sm font-semibold text-slate-900">Browse categories</h3>
                  <p className="text-sm text-slate-500 mt-0.5">Explore dining, wellness, activities and more</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 rounded-2xl bg-teal-50 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-teal-600">2</span>
                </div>
                <div className="pt-1">
                  <h3 className="text-sm font-semibold text-slate-900">Find quality places</h3>
                  <p className="text-sm text-slate-500 mt-0.5">Featured placements are clearly labelled</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 rounded-2xl bg-teal-50 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-teal-600">3</span>
                </div>
                <div className="pt-1">
                  <h3 className="text-sm font-semibold text-slate-900">Connect directly</h3>
                  <p className="text-sm text-slate-500 mt-0.5">Call, get directions, or visit their website</p>
                </div>
              </div>
            </div>
          </section>

          {/* For Businesses */}
          <section className="layer-card p-5">
            <h2 className="text-lg font-semibold text-slate-900 mb-3">
              For Businesses
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed mb-5">
              Want to list your business on Disqover? Reach visitors at the moment 
              they're looking for recommendations.
            </p>
            <div className="space-y-3">
              <Link 
                to="/partner"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-teal-600 text-white text-sm font-semibold hover:bg-teal-700 transition-colors layer-floating"
              >
                Get Listed
                <ArrowRight className="w-4 h-4" />
              </Link>
              <div>
                <a 
                  href="mailto:hello@disqover.com.au"
                  className="inline-flex items-center gap-2 text-sm font-medium text-teal-600"
                >
                  <Mail className="w-4 h-4" />
                  hello@disqover.com.au
                </a>
              </div>
            </div>
          </section>

          {/* Location */}
          <section className="layer-card p-5">
            <h2 className="text-lg font-semibold text-slate-900 mb-3">
              Your destination
            </h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              You're viewing recommendations for the <span className="font-semibold">Gold Coast, Queensland</span>. 
              Businesses shown are curated for quality and relevance.
            </p>
          </section>

          {/* Footer */}
          <div className="text-center pt-6 pb-2 space-y-4">
            <a 
              href="https://app.disqover.com.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-teal-600 font-medium"
            >
              <Globe className="w-3.5 h-3.5" />
              disqover.com.au
            </a>
            <p className="text-xs text-slate-400">
              © 2026 Disqover. All rights reserved.
            </p>
            <div className="pt-3">
              <Link 
                to="/admin/login"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-2xl bg-slate-100 text-slate-500 text-xs font-medium hover:bg-slate-200 transition-colors"
              >
                Admin Portal
                <ArrowRight className="w-3 h-3" />
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
